require('./helpers/bundle-manifest').register(JSON.parse("{\"EVgbq\":\"index.152a2424.js\",\"ee16w\":\"sprite.18f6dce1.svg\"}"));